import axios from "axios";
import { createApiError } from "./errorUtils";

const API_URL = process.env.REACT_APP_API_URL;

export function uploadFotos(produtoId, descricao, arquivos) {
  const formData = new FormData();
  formData.append("produtoId", produtoId);
  formData.append("descricao", descricao);

  arquivos.forEach((arquivo) => {
    formData.append("fotos", arquivo);
  });

  return axios
    .post(`${API_URL}/fotos/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((error) => {
      throw createApiError(error, "Erro ao enviar as fotos.");
    });
}

export function getFotos(produtoId) {
  return axios.get(`${API_URL}/fotos/${produtoId}`).catch((error) => {
    throw createApiError(error, "Erro ao obter fotos do produto.");
  });
}

export function getFotosPorLoja(lojaId, params = {}) {
  return axios.get(`${API_URL}/fotos/loja/${lojaId}`, { params }).catch((error) => {
    throw createApiError(error, "Erro ao obter fotos do produto.");
  });
}

export function deletarFoto(fotoId) {
  return axios.delete(`${API_URL}/fotos/${fotoId}`).catch((error) => {
    throw createApiError(error, "Erro ao excluir a foto.");
  });
}

export function toggleFotoCapa(fotoId) {
  return axios.patch(`${API_URL}/fotos/${fotoId}/capa`).catch((error) => {
    throw createApiError(error, "Erro ao definir foto de capa.");
  });
}

export function auditarFotosPorLoja(lojaId) {
  return axios
    .get(`${API_URL}/fotos/auditoria/${lojaId}`, { withCredentials: true })
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao auditar as fotos da loja.");
    });
}

export function limparArquivosSemRegistro(lojaId) {
  return axios
    .post(
      `${API_URL}/fotos/auditoria/${lojaId}/limpar-arquivos-sem-registro`,
      {},
      { withCredentials: true }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao limpar arquivos sem registro.");
    });
}

export function limparRegistrosSemArquivo(lojaId) {
  return axios
    .post(
      `${API_URL}/fotos/auditoria/${lojaId}/limpar-registros-sem-arquivo`,
      {},
      { withCredentials: true }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao limpar registros sem arquivo.");
    });
}
